function showSignIn(event) {
    if (event) event.preventDefault(); 
    document.getElementById('signin-form').style.display = 'block';
    document.getElementById('recover').style.display = 'none';
    window.location.hash = 'login'; 
    window.scrollTo(0, 0); 
}

function showRecover(event) {
    if (event) event.preventDefault(); 
    document.getElementById('signin-form').style.display = 'none';
    document.getElementById('recover').style.display = 'block';
    window.location.hash = 'recover'; 
    window.scrollTo(0, 0); 
}


if (window.location.hash === '#recover') {
    showRecover();
} else {
    showSignIn();
}

